'use client'

import { Box, Text, Stack, Link } from '@chakra-ui/react';

export default function Footer() {
  return (
    <Box as="footer" py={6} >
      <Stack spacing={4} textAlign="center">
        <Text>
        <br />
                <strong>Contact Us:</strong>{' '}
                <a
                    href={`mailto:papi@papirazzi.app?subject=${encodeURIComponent(
                        'Inquiry Regarding PapiRazzi'
                    )}&body=${encodeURIComponent(
                        'Hello Papirazzi Support Team,\n\nI have a question regarding your terms and policies. Could you please assist me with the following:\n\n[Your Question Here]\n\nThank you,\n[Your Name]'
                    )}`}
                    style={{ color: '#FF0080', textDecoration: 'underline' }}
                    >
                    papi@papirazzi.app
                </a>

        </Text>
        <Link href="/terms" color="blue.400">
          Terms of Service, Privacy Policy, & Refunds
        </Link>
      </Stack>
    </Box>
  );
};

